// extracted by mini-css-extract-plugin
export var menuItem = "x_tN d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "x_tP d_Z d_bz d_bP";
export var menuMainLink = "x_tQ d_f0 d_dB";
export var menuLink = "x_tR d_f0 d_dB";
export var icon = "x_p9 d_bC d_bP";
export var divider = "x_tS d_bC d_bP";
export var sublinks = "x_tT";
export var link = "x_mC";
export var Link = "x_sC v_sC v_rX v_sg";